// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606111133/js/" + chunkId + "." + {"44":"6d983378","225":"a9cc2566","481":"f7635883","486":"12f973d6","770":"0d9b96cf"}[chunkId] + ".0.5730817375629449.chunk.js";
};